import { Typography } from "@braintrust/braintrust-ui-components";
import type { StripeACHPayment } from "@js/types/payments";

import styles from "../style.module.scss";

type StripeACHItemProps = {
  paymentMethod: StripeACHPayment;
};

export const StripeACHItem = ({ paymentMethod }: StripeACHItemProps) => (
  <>
    <div className={styles.paymentMethodsListItemDetailsItem}>
      <Typography
        component="p"
        size="small"
        fontWeight={500}
        color="grey-2"
        className={styles.paymentMethodsListItemDetailsItemName}
        sx={{ textTransform: "uppercase" }}
      >
        Account Number
      </Typography>
      <Typography component="p">
        {paymentMethod.method.account_number}
      </Typography>
    </div>
    <div className={styles.paymentMethodsListItemDetailsItem}>
      <Typography
        component="p"
        size="small"
        fontWeight={500}
        color="grey-2"
        className={styles.paymentMethodsListItemDetailsItemName}
        sx={{ textTransform: "uppercase" }}
      >
        Routing Number
      </Typography>
      <Typography component="p">
        {paymentMethod.method.routing_number}
      </Typography>
    </div>
    <div className={styles.paymentMethodsListItemDetailsItem}>
      <Typography
        component="p"
        size="small"
        fontWeight={500}
        color="grey-2"
        className={styles.paymentMethodsListItemDetailsItemName}
        sx={{ textTransform: "uppercase" }}
      >
        Currency
      </Typography>
      <Typography component="p" sx={{ textTransform: "uppercase" }}>
        {paymentMethod.method.currency}
      </Typography>
    </div>
  </>
);
